import { Component, Input, OnInit } from '@angular/core';
import { Photo } from '../../../shared/models/cameralla-photo.model';
import { CamerallaAuthService } from '../../../shared/services/authentication-services/cameralla-auth.service';
import { UserStatusConstant } from "../../../shared/constants/user-status-constant";
import { FriendService } from "../../../shared/services/friend.service";

@Component({
    selector: 'app-photo-information',
    templateUrl: './photo-information.component.html',
})
export class PhotoInformationComponent implements OnInit {
    @Input('photoDetails') photoDetails: Photo;
    @Input('portfolio') photosByUser: Photo[];
    localUserId;

    constructor(private authService: CamerallaAuthService,
                private friendService: FriendService) {
        this.localUserId = +this.authService.getLocalUserInfo()['id'];
    }

    ngOnInit() {
        if (this.photoDetails.customer && this.photoDetails.customer.status == UserStatusConstant.DELETED) {
            this.photoDetails.customer.fullName = 'Deleted user';
            this.photoDetails.customer.avatar = '';
        }
    }

    tooltip(tooltip, $event) {
        $event.stopPropagation();
        if (tooltip.isOpen()) {
            tooltip.close();
        } else {
            tooltip.open();
        }

    }
    
    checkHasFollow(userId, checkIsSubscribe= null) {
        return this.friendService.checkHasFollow(userId, checkIsSubscribe)
    }
    
    followRequest(userId, action) {
        return this.friendService.followRequest({
            addresseeId : userId,
            action :action
        }).toPromise().then()
    }
}
